import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { Drzava } from './drzava';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';

@Component({
  selector: 'yt-drzava-modal-update',
  templateUrl: './drzava-modal-update.component.html'
})
export class DrzavaModalUpdateComponent extends BaseModalUpdateComponent<Drzava> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Drzava>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
